import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  HostListener,
  inject,
  Input,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';

import { ContactCardStateService } from '../contact-info-on-hover/contact-info-on-hover.directive';
import { CardDataType } from '../contact-info-types';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';

@Component({
  selector: 'glxy-contact-info-card',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    OverlayModule,
    GalaxyAvatarModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    MatCardModule,
    ClipboardModule,
    GalaxyTooltipModule,
  ],
  templateUrl: './contact-info-card.component.html',
  styleUrls: ['./contact-info-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactInfoCardComponent implements OnInit {
  @HostBinding('class') class = 'glxy-contact-info-card';

  @HostBinding('class.is-popover') @Input() cardIsPopover = false;

  @Input() cardData?: CardDataType;

  @Input() showDefaultActions = true;

  @Input() actionsRef: TemplateRef<unknown> | undefined = undefined;

  private router = inject(Router);

  cardType: 'user' | 'business' = 'user';

  popoverIsHovered = false;

  fullBusinessAddress?: string;

  stateService = inject(ContactCardStateService);

  isCopied = false;

  ngOnInit() {
    this.generateAddressString();
  }

  @HostListener('mouseenter') onMouseEnter(): void {
    this.popoverIsHovered = true;
  }

  @HostListener('mouseleave') onMouseLeave(): void {
    this.popoverIsHovered = false;
  }

  handleProfileButtonClick() {
    if (this.cardData?.profileButtonAction) {
      this.cardData.profileButtonAction();
      return;
    }

    if (this.cardData?.profileButtonUrlUseRouterLink) {
      if (Array.isArray(this.cardData.profileButtonUrl)) {
        this.router.navigate(this.cardData.profileButtonUrl);
      } else {
        this.router.navigate([this.cardData.profileButtonUrl]);
      }
    }
    // If the link is a normal link, we handle this in the
    // template with the [href] attribute
  }

  generateAddressString() {
    // prettier-ignore
    if (this.cardData?.businessAddress) {
      this.fullBusinessAddress = '';
      const addy = this.cardData.businessAddress

      // build the address string
      if (addy.address1)
        this.fullBusinessAddress += addy.address1 + ', ';
      if (addy.address2)
        this.fullBusinessAddress += addy.address2 + ', ';
      if (addy.city)
        this.fullBusinessAddress += addy.city + ', ';
      if (addy.state)
        this.fullBusinessAddress += addy.state;

      if (addy.country || addy.zip)
        this.fullBusinessAddress += '\n';
      if (addy.country)
        this.fullBusinessAddress += addy.country + ', ';
      if (addy.zip)
        this.fullBusinessAddress += addy.zip;

      this.fullBusinessAddress = this.fullBusinessAddress.trim();
      if (this.fullBusinessAddress.endsWith(','))
        this.fullBusinessAddress = this.fullBusinessAddress.slice(0, -1);
    }
  }

  copyClicked() {
    this.isCopied = true;
    window.setTimeout(() => {
      this.isCopied = false;
    }, 3000);
  }
}
